const yaloImages = {
  logo_yalo_beneficios: require('./logo_yalo_beneficios.png'),
  logo_yalo: require('./yalo.png'),
  yalo_flor: require('./Yalo_flor_64px.png'),
  icone_yalo: require('./yalo-icone.png')
}

export default yaloImages
